import $ from 'jquery'
import 'slick-carousel'

const MOBILE_QUERY = '(max-width: 767px)'

export default el => {
  const grid = el.querySelector('.redesign-image-grid__grid')
  if (!grid) return

  const itemCount = grid.children.length
  if (itemCount <= 1) return

  const slider = $(grid)
  const mediaQuery = window.matchMedia(MOBILE_QUERY)
  let resizeRaf = null
  let alignmentRaf = null

  const isInitialized = () => slider.hasClass('slick-initialized')

  // Pulls the last slide flush against the right edge, leaving a gutter equal to
  // the section padding (mirrors the list's padding-left). `animate` eases the
  // margin shift when the slide settles; resize/init apply it instantly.
  const applyLastSlideAlignment = (slickInstance, animate) => {
    if (!isInitialized() && !slickInstance) return

    const slick = slickInstance || slider.slick('getSlick')
    const track = grid.querySelector('.slick-track')

    if (!slick || !track) return

    track.style.transition = animate ? 'margin-left 0.35s ease' : 'none'

    if (slick.currentSlide !== itemCount - 1) {
      track.style.marginLeft = ''
      return
    }

    const list = grid.querySelector('.slick-list')
    const currentSlide = grid.querySelector('.slick-slide.slick-current')

    if (!list || !currentSlide) return

    const gutter = parseFloat(getComputedStyle(list).paddingLeft) || 0
    const listRect = list.getBoundingClientRect()
    const slideRect = currentSlide.getBoundingClientRect()
    const offset = listRect.right - gutter - slideRect.right

    track.style.marginLeft = offset > 0 ? `${offset}px` : ''
  }

  const alignLastSlide = (event, slickInstance, animate) => {
    if (alignmentRaf) {
      window.cancelAnimationFrame(alignmentRaf)
    }

    alignmentRaf = window.requestAnimationFrame(() => {
      alignmentRaf = null
      applyLastSlideAlignment(slickInstance, animate)
    })
  }

  // Animate only after the slide settles (afterChange); init/setup snap into place.
  const onSlickEvent = (event, slickInstance) => {
    const animate = !!event && event.type === 'afterChange'
    alignLastSlide(event, slickInstance, animate)
  }

  const initSlider = () => {
    if (isInitialized()) return

    grid.classList.add('is-slider-enabled')

    slider.on('init afterChange', onSlickEvent)

    slider.slick({
      arrows: false,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToScroll: 1,
      slidesToShow: 1.36,
      swipeToSlide: true
    })
  }

  const destroySlider = () => {
    if (alignmentRaf) {
      window.cancelAnimationFrame(alignmentRaf)
      alignmentRaf = null
    }

    if (isInitialized()) {
      slider.off('init afterChange', onSlickEvent)
      slider.slick('unslick')
    }

    grid.classList.remove('is-slider-enabled')
  }

  const syncSlider = () => {
    if (mediaQuery.matches) {
      initSlider()
      return
    }

    destroySlider()
  }

  const handleResize = () => {
    if (resizeRaf) return

    resizeRaf = window.requestAnimationFrame(() => {
      resizeRaf = null
      syncSlider()

      if (isInitialized()) {
        slider.slick('setPosition')
        alignLastSlide(null, slider.slick('getSlick'))
      }
    })
  }

  syncSlider()

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', syncSlider)
  } else {
    mediaQuery.addListener(syncSlider)
  }

  window.addEventListener('resize', handleResize, { passive: true })
}
